import { Record } from "immutable";

export const measureValueFromJSON = (json: Partial<IMeasureValue>): MeasureValueRecord => {
  const record: IMeasureValueRecord = { ...(json as any) };

  return new MeasureValueRecord(record);
};

export interface IMeasureValue {
  measurement: string;
  formula: string;
  formula_uom: string;
}

export interface IMeasureValueRecord {
  measurement: string;
  formula: string;
  formula_uom: string;
}

export const defaultMeasureValueProps: IMeasureValueRecord = {
  formula: "",
  formula_uom: "",
  measurement: "",
};

export class MeasureValueRecord extends Record(defaultMeasureValueProps) implements IMeasureValueRecord {}
